module.exports = __webpack_public_path__ + "img/icon-leave.60292015.svg";